module.exports = __webpack_public_path__ + "img/S9012-IL.63ff614e.jpg";